import React from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "../hooks/usePermission";

interface ModuleGuardProps {
    module: string | string[];
    children: React.ReactNode;
}

const ModuleGuard: React.FC<ModuleGuardProps> = ({ module, children }) => {
    const { hasPermission, isLoading } = usePermission();

    if (isLoading) return <div className="loading_state">Loading...</div>;

    const modules = Array.isArray(module) ? module : [module];
    const isAuthorized = modules.some(m => hasPermission(m, "isView"));

    if (!isAuthorized) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default ModuleGuard;
